import MKBox from "components/MKBox";
import BrandColumn from "./BrandColumn";
import GeneralLinks from "./GeneralLinks";
import ServicesLinks from "./ServicesLinks";
import NewsletterSignup from "./NewsletterSignup";
import Copyright from "./Copyright";

export default function Footer() {
  return (
    <MKBox component="footer" bgcolor="white" py={6} px={{ xs: 3, md: 10 }} boxShadow="lg">
      <MKBox
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        rowGap={4}
      >
        <BrandColumn />
        <GeneralLinks />
        <ServicesLinks />
      </MKBox>
      <NewsletterSignup />
      <Copyright />
    </MKBox>
  );
}
